/**
 * Trigger: tr_incomes_delete
 * Purpose: Update account balances and clean up daily balances when an income is hard deleted
 * Table: incomes
 * Event: BEFORE DELETE
 */
export const TR_INCOMES_DELETE = `
CREATE TRIGGER tr_incomes_delete
BEFORE DELETE ON incomes
FOR EACH ROW
BEGIN
  UPDATE account_balances
  SET incomes_amount = incomes_amount - old.amount
  WHERE old.is_deleted = 0
    AND account_id = old.account_id
    AND currency_id = old.currency_id;

  UPDATE account_daily_balances
  SET incomes_amount = incomes_amount - old.amount
  WHERE old.is_deleted = 0
    AND account_id = old.account_id
    AND currency_id = old.currency_id
    AND balance_date = old.income_date;

  DELETE FROM account_daily_balances
  WHERE account_id = old.account_id
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_activity_dates
  WHERE account_id = old.account_id
    AND NOT EXISTS (
    SELECT _id FROM account_daily_balances
    WHERE account_daily_balances.account_id = account_activity_dates.account_id
      AND account_daily_balances.balance_date = account_activity_dates.activity_date
  );
END;
`;
